import Collection from 'lib/Collection';
import Subscription from 'entities/Subscription';

class Subscriptions extends Collection<Subscription> {
  initialize() {
    this.url = '/subscriptions';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Subscription' is missing the followin... Remove this comment to see the full error message
    this.model = Subscription;
  }

  getGroupIds() {
    return this.map((subscription) => subscription.getGroupId());
  }
}

export default Subscriptions;
